import React, { useEffect, useState } from "react";
import { notification } from "antd";
import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom"

import { addeditdata } from '../../../controllers/V1/products/productController'

import LoadingEffect from "../../../components/Loading/LoadingEffect";
import ProductUploadImage from "../../../components/ImageUploader/ImgUploader";
import "./product.css";
import { usePermissions } from "../../../controllers/PermissionContext";

const ProductListEditPage = () => {
  const PERMISSION = usePermissions("usersPermission");
  const location = useLocation();
  const state = location.state;
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditData] = useState(state || []);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenUpload, setIsOpenUpload] = useState(false);
  const [childData, setChildData] = useState('');
  const handleUploadImage = () => setIsOpenUpload(!isOpenUpload);

  const [imgUrl, setImgUrl] = useState(ADDEDITDATA?.image || "");

  const handleChildData = (data) => {
    setChildData(data);
    if (data?._id) {
      setAddEditData((prevState) => ({
        ...prevState,
        image: data?.url || '',
      }));

    }

  };
  /*********************************************************
   *  This function is use to handle input change
   *********************************************************/
  const handleChange = (e) => {
    setAddEditData((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const form = new FormData(event.target);
      const params = {
        editId: form.get('edit_id') || ADDEDITDATA?._id,
        name: form.get("name"),
        description: form.get("description"),
        seq_order : form.get("seq_order"),
        image: imgUrl,
      };
      const isValidate = await validateFormData(params);

      if (isValidate === true) {
        const res = await addeditdata(params);
        if (res.status === true) {
          notification.open({
            message: "Success.",
            description: `Data successfully added/updated.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/product/list");
        } else {
          notification.open({
            message: "Error.",
            description: `${res.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Validation Error.",
          description: `Please check the form and try again.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      console.log("Error during submission:", error);
    }
  };

  /*********************************************************
   *  This function is used to validate form data before submit
   *********************************************************/
  const validateFormData = (formData) => {
    try {
      const { name, description, image } = formData;
      let isValid = true;

      if (!name || name.trim() === "") {
        setError((prevError) => ({ ...prevError, name: "Product name is required." }));
        isValid = false;
      }

      if (!description || description.trim() === "") {
        setError((prevError) => ({ ...prevError, description: "Description is required." }));
        isValid = false;
      }

      if (!image) {
        setError((prevError) => ({ ...prevError, image: "Please select an image upload type." }));
        isValid = false;
      }

      return isValid;
    } catch (error) {
      console.log("Validation error:", error);
      return false;
    }
  };
  useEffect(() => {
    document.title = `Orbit Kuwait || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } Users`;
  }, []);

  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <React.Fragment>
            <h5 className="inventory_edit_page_heading"> {ADDEDITDATA?._id ? `Edit` : `Add`} Product </h5>
          </React.Fragment>
          <Link to={"/product/list"}>
            <React.Fragment>
              <button type="button" className="btn btn-secondary"> <ArrowLeftOutlined /> Back </button>
            </React.Fragment>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="name" className="all_section_for_label_main_class">
                      <span style={{ color: "red" }}>*</span>Product Name:
                    </label>
                    <input
                      title="Enter product name."
                      placeholder="Enter product name."
                      type="text"
                      name="name"
                      className="form-control store_input_field"
                      id="name"
                      value={ADDEDITDATA?.name || ""}
                      onChange={handleChange}
                    />
                    {error.name && <p style={{ color: "red" }}>{error.name}</p>}
                  </div>

                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="description" className="all_section_for_label_main_class">
                      <span style={{ color: "red" }}>*</span>Description:
                    </label>
                    <input
                      title="Enter description."
                      placeholder="Enter description."
                      type="text"
                      name="description"
                      className="form-control store_input_field"
                      id="description"
                      value={ADDEDITDATA?.description || ""}
                      onChange={handleChange}
                    />
                    {error.description && <p style={{ color: "red" }}>{error.description}</p>}
                  </div>

                  <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="seq_order" className="all_section_for_label_main_class">
                      <span style={{ color: "red" }}>*</span>Seq. Order:
                    </label>
                    <input
                      title="Enter sequence order."
                      placeholder="Enter sequence order."
                      type="number"
                      name="seq_order"
                      className="form-control store_input_field"
                      id="seq_order"
                      value={ADDEDITDATA?.seq_order || ""}
                      onChange={handleChange}
                    />
                    {error.description && <p style={{ color: "red" }}>{error.description}</p>}
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label htmlFor="image" className="all_section_for_label_main_class">
                      <span style={{ color: "red" }}>*</span> Image Upload:
                    </label>
                    <div className="image_select_btn">
                      <button type="button" className="btn btn-light categories_cancel_button" onClick={() => { handleUploadImage() }}>Select</button>
                      <span>{imgUrl || ""}</span>
                    </div>
                  </div>


                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center mt-4">
                    <div className="verndor_dashboard_add_edit_button">
                      <button type="submit" className="btn btn-primary inventory_save_button" disabled={(PERMISSION?.fullAccess === 'Y' || PERMISSION?.addEdit === 'Y') ? false : true}>
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
      <ProductUploadImage openUpload={isOpenUpload} toggleUploadOpen={handleUploadImage} setImgUrl={setImgUrl} />
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default ProductListEditPage;
